// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"1d339b15","263":"14597789","930":"dc58e8ac"}[chunkId] + ".chunk.css";
};